import useMarkRead from "./useMarkRead";

export default useMarkRead;